import Pagination from 'antd/es/pagination';

export default Pagination;
